import { getI18n } from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import PartnershipTagsRecipientsScreen from './containers/PartnershipTagsRecipientsScreenContainer';

const register = () => {
  Logger.log('debug', `partnershipTagsRecipients.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'partnershipTagsRecipients', 'routes'])) {
    Events.dispatch('ADD_MAIN_ROUTES', {
      PartnershipTagsRecipientsScreen: [
        'PrivateRoute',
        '/partnership-tags-recipients',
        true,
        PartnershipTagsRecipientsScreen,
        getI18n().t('partnership_tags_recipients_route_list'),
      ],
    });
  }
};

export default register;

Logger.log('silly', `partnershipTagsRecipients.register() loaded.`);
